import { AssetIcon } from '@dapp/multi-lib/sdaoui/AssetIcon';
import { getNetworkByChainId } from '@dapp/multi-lib/network';
import { DynaVault } from '../../../../api/DynaVaultsAPI';
import { getDepositTokenByAddress } from 'structure/pv2/vault/utils/depositTokenList';
import {
  getNetworkIconUrlByChaiId,
  getStaticAssetUrl,
  getTokenIconUrl,
} from 'utils/url';

interface VaultDepositAssetIconProps {
  vault: DynaVault;
  depositAssetSymbol?: string;
  size?: 'small' | 'normal';
}

export const VaultDepositAssetIcon = ({
  vault,
  depositAssetSymbol,
  size,
}: VaultDepositAssetIconProps) => {
  const configuredDepositAsset = getDepositTokenByAddress(
    vault.chainId,
    vault.depositToken || vault.asset
  );
  const assetSymbol = depositAssetSymbol || configuredDepositAsset?.symbol;

  return (
    <AssetIcon
      size={size}
      assetImg={
        assetSymbol
          ? getTokenIconUrl(assetSymbol)
          : getStaticAssetUrl('/sfi/static/image/token/undefined.png')
      }
      networkImg={getNetworkIconUrlByChaiId(vault.chainId)}
      assetName={assetSymbol ? `${assetSymbol} deposit asset` : 'Deposit asset'}
      networkName={getNetworkByChainId(vault.chainId)?.name}
    />
  );
};
